<footer class="footer">
  <div class="footer-container">

    <div class="footer-newsletter">
      <div class="footer-newsletter-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
      </div>
      <h2>Esteja sempre a frente!</h2>
      <p>Assine nossa Newsletter gratúita e receba conteúdos exclusivos de como ótimizar sua operação contábil.</p>
    </div>

    <div class="footer-divider"></div>

    <div class="footer-main">

      <div class="footer-brand">
        <img src="assets/img/logo.png" alt="Mister Contador" class="footer-logo" />
      </div>

      <div class="footer-col">
        <h4>Páginas</h4>
        <ul>
          <li><a routerLink="/">Homepage</a></li>
          <li><a routerLink="/solucao">Solução</a></li>
          <li><a routerLink="/" fragment="integracoes">Integrações</a></li>
        </ul>
      </div>

      <div class="footer-col">
        <!-- <h4>Páginas</h4> -->
        <ul>
          <li><a routerLink="/conteudos">Blog</a></li>
          <li><a href="https://tawk.to/chat/615d935225797d7a890299f9/1hlda7fs2" target="_blank" rel="noopener noreferrer">Ajuda</a></li>
          <li><a routerLink="/politica-privacidade">Política de Privacidade</a></li>
          <li><a routerLink="/politica-privacidade">Termos de Uso</a></li>
        </ul>
      </div>

      <div class="footer-col footer-col-right">
        <div class="footer-social">
          <a href="https://www.instagram.com/mistercontador" target="_blank" rel="noopener noreferrer" class="footer-social-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
          </a>
        </div>
        <div class="footer-contatos">
          <span>Contatos:</span>
          <a href="https://api.whatsapp.com/send/?phone=5548991707731" target="_blank" rel="noopener noreferrer">Comercial</a>
          <a href="https://tawk.to/chat/615d935225797d7a890299f9/1hlda7fs2" target="_blank" rel="noopener noreferrer">Suporte</a>
          <a href="https://api.whatsapp.com/send/?phone=5548991546310" target="_blank" rel="noopener noreferrer">Financeiro</a>
        </div>
        <p class="footer-address">Rua Trajano, 265 - Centro, Florianópolis, SC</p>
      </div>

    </div>

  </div>

  <div class="footer-bottom">
    <div class="footer-bottom-inner">
      <span>Mister Contador • 2023 • Todos os direitos reservados</span>
      <span >Site desenvolvido por <a style="text-decoration: none;" href="https://www.linkedin.com/in/nicomota/">Nícolas da Mota</a></span>
    </div>
  </div>

</footer>
